import type {CompRef} from '@wix/document-services-types'
import {createHookDefinition} from '../../utils/hooksUtils'
import type {HookEventData} from '../hooks/hooks'

interface ContextDetachAfterData {
    compRef: CompRef
    contextType: string
}

export interface ContextDetachAfterEvent extends ContextDetachAfterData, HookEventData<'context_detach_after'> {}

export const CONTEXTS_HOOKS = {
    DETACH_AFTER: createHookDefinition<'context_detach_after', ContextDetachAfterData>('context_detach_after')
} as const
